export class CollaboratorType {
    id: number;
    name:string;
    
    constructor (id:number, name:string) {
        this.id = id;
        this.name = name;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/entities/collaborator-type.ts